module.exports = __webpack_public_path__ + "static/media/OrangeAI_Logo_trimmed.61ad121f.png";